export default {
  data() {
    return {
      scrollTop: 0,
    }
  },
  methods: {
    initScroll(e) {
      if (e && e.target && e.target.scrollTop) {
        this.scrollTop = e.target.scrollTop
      } else {
        this.scrollTop = 0
      }
    },
  },
  created() {
    document.body.addEventListener('scroll', this.initScroll)
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.initScroll)
  },
}
